module.exports = __webpack_public_path__ + "media/images/icons/checked-c42dc6ee3adba5c8718033dd61adeb9a.svg";